import axios from 'axios';
import { UNKNOWN_ERROR } from '../../../../helpers/Constants';

const fetchFundRatesServices = async fundId => {
  try {
    return await axios.get(`/api/funds/${fundId}/rates`);
  } catch (error) {
    throw new Error(error?.response?.data?.message ?? UNKNOWN_ERROR);
  }
};

// eslint-disable-next-line import/prefer-default-export
export { fetchFundRatesServices };
